import React, { useState } from 'react'
import { formatDate } from '../utils/dateUtils'
import PersonUi from './PersonUi'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import personApi from '../api/person/PersonApi'
import { PersonDto } from '../api/person/models/PersonDto'

interface SearchPeopleModalProps {
    onClose: () => void
    onSelect: (person: PersonDto) => void
}

function SearchPeopleModal({
    onClose,
    onSelect,
}: SearchPeopleModalProps): React.JSX.Element {
    const [searchTerm, setSearchTerm] = useState('')
    const [foundPeople, setFoundPeople] = useState<PersonDto[]>([])

    function handleSearchChange(
        event: React.ChangeEvent<HTMLInputElement>,
    ): void {
        const value = event.target.value
        setSearchTerm(value)
    }

    async function searchClick() {
        const searchResults = await personApi.searchPersons(searchTerm)

        setFoundPeople(searchResults.persons)
    }

    return (
        <div className="modal-container">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Select a Person</h2>
                    <button className="danger-button" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className='flex flex-col '>
                    <input
                        className="form-input"
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                    <button className="primary-button my-4" onClick={searchClick}>
                        Search
                    </button>
                </div>
                {foundPeople.length > 0 && (
                    <table className="main-table max-w-[200px]">
                        <tbody>
                            {foundPeople.map((person) => (
                                <tr key={person.id}>
                                    <td>
                                        <PersonUi person={person} />
                                        <button
                                            className="primary-button"
                                            onClick={() => onSelect(person)}
                                        >
                                            Select
                                        </button>
                                    </td>
                                    <td>
                                        <table className="nested-table">
                                            <colgroup>
                                                <col style={{ width: '35%' }} />
                                                <col style={{ width: '35%' }} />
                                                <col style={{ width: '15%' }} />
                                                <col style={{ width: '15%' }} />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>Company Name</th>
                                                    <th>Job Title</th>
                                                    <th>Start Date</th>
                                                    <th>End Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {person
                                                    .workedAts!.slice()
                                                    .sort((a, b) => {
                                                        if (!a.startDate)
                                                            return -1 // If a.startDate is missing, place it at the top
                                                        if (!b.startDate)
                                                            return 1 // If b.startDate is missing, place a after b
                                                        return (
                                                            new Date(
                                                                b.startDate,
                                                            ).getTime() -
                                                            new Date(
                                                                a.startDate,
                                                            ).getTime()
                                                        ) // Descending order by startDate
                                                    })
                                                    .map((work, index) => (
                                                        <tr key={index}>
                                                            <td
                                                                style={{
                                                                    width: '40%',
                                                                }}
                                                            >
                                                                {
                                                                    work.company!
                                                                        .name
                                                                }
                                                            </td>
                                                            <td
                                                                style={{
                                                                    width: '40%',
                                                                }}
                                                            >
                                                                {work.jobTitle}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    width: '10%',
                                                                }}
                                                            >
                                                                {formatDate(
                                                                    work.startDate,
                                                                )}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    width: '10%',
                                                                }}
                                                            >
                                                                {formatDate(
                                                                    work.endDate,
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                <button className="danger-button mt-4" onClick={onClose}>
                    Close
                </button>
            </div>
        </div>
    )
}

export default SearchPeopleModal
